module.exports = __webpack_public_path__ + "static/media/ic_reload_gray.227835de.svg";